import {Modal} from "antd";
import {useState} from "react";
import copyToClipboard from "../../../utils/copy";
import { useTranslation } from "../../../i18n";

function ShareIcon() {
    const { t } = useTranslation();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [link] = useState(window.location.origin);
    const showModal = () => {
        setIsModalOpen(true);
    };
    const handleOk = () => {
        setIsModalOpen(false);
        window.location=link
    };
    const handleCancel = () => {
        setIsModalOpen(false);
        copyToClipboard(link);
    };
    function iconOnClick(){
        showModal();
    }
    return (<>
    <span onClick={iconOnClick}>
        <svg t="1728233285833" className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
             p-id="7675" width="0.75em" height="0.75em">
            <path
                d="M384 64a64 64 0 1 1 0 128H192a32 32 0 0 0-32 32v608a32 32 0 0 0 32 32h576a32 32 0 0 0 32-32v-160a64 64 0 1 1 128 0v160a160 160 0 0 1-160 160H192a160 160 0 0 1-160-160V224a160 160 0 0 1 160-160z m416 32l224 208-224 208v-118.144l-47.2 1.152a576.992 576.992 0 0 0-491.2 298.56L256 704l45.44-145.408A512 512 0 0 1 788.8 199.296l11.2 0.096V96z"
                fill="black" p-id="7676"></path>
        </svg>
        </span>
        <Modal
            title={t("common.share")}
            open={isModalOpen}
            onOk={handleOk}
            okText={t("common.go")}
            cancelText={t("common.copyLink")}
            onCancel={handleCancel}
        >
            <a href={link}>{link}</a>
        </Modal>
    </>)
}

export default ShareIcon
